document.addEventListener('DOMContentLoaded', function () {
  const env_message = document.querySelector('.env_message');
  if (env_message === null) return; // ない場合は何もしない
  env_message.style.display = 'none !important';
});

// function init() {
//   ui_tab();
//   hide_pointsection_order();
//   view_change_init();
//   related_product();
// }

function view_change_init() {
  const view_change = document.querySelector('.view_change');
  if (view_change === null) return; // ない場合は何もしない

  const id_orderlist_form = document.getElementById('orderlist_form');
  // console.debug(id_orderlist_form);

  const view_change_buttons = view_change.querySelectorAll('a');
  // console.debug(view_change_buttons);
  view_change_buttons.forEach(function (button, i) {
    if (i === 0) {
      if (id_orderlist_form === null) {
        button.classList.add('active');
      }
    }
    if (i === 1) {
      if (id_orderlist_form !== null) {
        button.classList.add('active');
      }
    }
  });
}

function hide_pointsection_order() {
  const usepoint_confirm = document.querySelector('.usepoint_confirm');
  if (usepoint_confirm === null) return; // ない場合は何もしない

  //console.debug(usepoint_confirm.previousElementSibling);

  // usepoint_confirm の隣のDOMも非表示にする
  // usepoint_confirm.previousElementSibling.previousElementSibling.style.display = 'none';
  // usepoint_confirm.previousElementSibling.style.display = 'none';
  // usepoint_confirm.style.display = 'none';

  usepoint_confirm.previousElementSibling.previousElementSibling.remove();
  usepoint_confirm.previousElementSibling.remove();
  usepoint_confirm.remove();
}

function ui_tab() {
  const tabWrapper = document.querySelectorAll('.tab-wrapper');

  //console.debug(tabWrapper);

  // console.debug(tabWrapper);
  if (tabWrapper === null) return; // ない場合は何もしない

  tabWrapper.forEach(function (tab) {
    const tabButtons = tab.querySelectorAll('.tab-button');
    //console.debug(tabButtons);

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        const tabContent = tab.querySelectorAll('.tab-contents');
        const tabButton = tab.querySelectorAll('.tab-button');
        const tabButtonId = e.target.dataset.tab;
        //console.debug(tabButtonId);

        tabContent.forEach(function (content) {
          //console.debug(content);
          if (content.dataset.tab === tabButtonId) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });

        tabButton.forEach(function (button) {
          if (button.dataset.tab === tabButtonId) {
            button.classList.add('active');
          } else {
            button.classList.remove('active');
          }
        });
      });
    });
  });
}

// テーブルにデータを追加する関数
function populateTable(data) {
  const tbody = document.querySelector('#product-table tbody');

  data.forEach((product) => {
    const row = document.createElement('tr');

    // 各セルを作成
    const handleCell = document.createElement('td');
    const handleLink = '/products/' + product.handle.toLowerCase() + '/';
    handleCell.innerHTML =
      '<a href="' + handleLink + '">' + product.handle + '</a>';

    const nameCell = document.createElement('td');
    nameCell.textContent = product.name;

    const priceCell = document.createElement('td');
    priceCell.textContent =
      product.price !== null ? formatPrice(product.price) : 'N/A';

    // 行にセルを追加
    row.appendChild(handleCell);
    row.appendChild(nameCell);
    // row.appendChild(priceCell);

    // テーブルに行を追加
    tbody.appendChild(row);
  });
}

// 3桁ごとにカンマを追加する関数
function formatPrice(price) {
  return price.toLocaleString(); // 数値を3桁区切りのカンマ付きに変換
}

function related_product() {
  // console.debug(related_product);
  // 変数 related_products が定義されていない場合は何もしない
  if (typeof related_products === 'undefined') {
    const productTable = document.querySelector('#product-table-wrapper');
    // DOMを削除
    if (productTable !== null) {
      productTable.remove();
    }
    // productTable.remove();

    return;
  }

  const getCurrentTime = () => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月は0から始まるので+1
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const currenttime = `${year}${month}${day}${hours}${minutes}${seconds}`;
    return currenttime;
  };

  // 使用例
  const currenttime = getCurrentTime();
  // console.log(currenttime); // 例: 20241025153045 (2024年10月25日 15時30分45秒)

  // JSONデータを取得してフィルタリングする例
  fetch('/user_data/packages/raku2pc/data/products.json' + '?d=' + currenttime)
    .then((response) => response.json())
    .then((data) => {
      const filteredProducts = data.filter((product) =>
        related_products.includes(product.handle)
      );
      populateTable(filteredProducts);

      // console.debug(filteredProducts);
    })
    .catch((error) => console.error('データの取得に失敗しました:', error));
}

function mobile_menu_init() {
  const mobile_menu_button = document.querySelector('#common-menu-button');
  const mobile_menu_nav = document.querySelector('#gloval_navi');

  if (mobile_menu_button === null || mobile_menu_nav === null) return;

  mobile_menu_button.addEventListener('click', function () {
    if (document.body.dataset.open === 'true') {
      document.body.dataset.open = 'false';
    } else {
      document.body.dataset.open = 'true';
    }
  });
}

function add_estimate_pdf_button() {
  const estimate_history = document.querySelectorAll('.estimate_history_list');
  // console.debug(estimate_history);

  if (estimate_history === null) return; // ない場合は何もしない

  estimate_history.forEach(function (history) {
    //const input = "estimate_id26";

    // 文字列と数字を分ける
    const result = history.id.match(/^([a-zA-Z_]+)(\d+)$/);

    if (result) {
      // const key = result[1];
      const value = Number(result[2]);

      // aタグを作成
      const link = document.createElement('a');
      link.href =
        'https://online.shinkawa.co.jp/mypage/estimate_pdf.php?estimate_id=' +
        value +
        '&print_mode=force&print_type=4';
      link.innerHTML = '<i class="fa fa-file-pdf-o"></i> PDFで見る';
      link.classList.add('nav_btn');
      link.setAttribute('target', '_blank'); // 新しいタブで開く場合
      link.setAttribute('rel', 'noopener noreferrer');

      // console.debug(link);

      // .estimate_info 要素に追加
      const infoContainer = history.querySelector('.estimate_info');
      const infoContainerSp = history.querySelector('.estimate_nav_area');

      if (infoContainerSp) {
        infoContainerSp.appendChild(link);
      } else {
        if (infoContainer) {
          infoContainer.appendChild(link);
        }
      }
    }

    // console.debug(history.id);
  });
}
function custom_staff_info_text() {
  const target = document.querySelector(
    '#mycontents_area table[summary="スタッフ登録内容変更"]'
  );
  if (target === null) return; // ない場合は何もしない

  // console.debug(target);
  const targetTableRows = target.querySelectorAll('tr');
  const targetTableRowTitle = targetTableRows[4].querySelector('th');
  // console.debug(targetTableRowTitle);
  for (const node of targetTableRowTitle.childNodes) {
    if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== '') {
      node.nodeValue = 'アカウント状況';
      break;
    }
  }
}

function custom_default_shipping_address() {
  const pcShippingTable = document.querySelector(
    '#undercolumn_shopping table[summary="お届け先の指定"]'
  );

  // console.debug(pcShippingTable);

  console.debug(company_department);

  if (company_department === null || company_department === undefined) return; // ない場合は何もしない
  let target;

  if (pcShippingTable) {
    target = {
      is_table: true,
      objects: document.querySelectorAll(
        '#undercolumn_shopping table[summary="お届け先の指定"] tr'
      ),
    };
  } else {
    target = {
      is_table: false,
      objects: document.querySelectorAll('#undercolumn .deliv_check'),
    };
  }

  const targetIsTable = target.is_table;
  const targetTableRows = target.objects;

  // console.debug(target);

  let selectNum = 0;
  let companyName;
  let companyNameInner;
  targetTableRows.forEach(function (row, i) {
    // お届け先のリストがテーブルかどうかを判定
    if (targetIsTable === true) {
      if (i > 0) {
        // お届け先の会社名を連番を付けて取得
        companyName = row.querySelector('.raku2_other_deliv_company_name_' + i);
        companyNameInner = companyName.textContent;
        // お届け先の会社名とログイン時の所属を比較
        if (companyNameInner.includes(company_department)) {
          selectNum = i;
        } else {
          selectNum = 1;
        }
      }
    } else {
      let i2 = i + 1;
      // お届け先の会社名を連番を付けて取得
      companyName = row.querySelector('.raku2_other_deliv_company_name_' + i2);
      companyNameInner = companyName.textContent;
      // お届け先の会社名とログイン時の所属を比較
      if (companyNameInner.includes(company_department)) {
        selectNum = i;
      } else {
        selectNum = 1;
      }
    }
  });
  // 一致したお届け先にチェックを入れる
  targetTableRows[selectNum].querySelector(
    'input[type="radio"]'
  ).checked = true;
}

function format_coupon_code() {
  const couponSections = document.querySelectorAll('#coupon_list');

  // console.debug(couponSections);

  let couponCode;
  if (couponSections.length === 0) return; // ない場合は何もしない

  couponSections.forEach(function (section) {
    couponCode = section.querySelector('#coupon_code');

    // couponCode に含まれるテキストのうち "[&nbsp;" と "&nbsp;]" 文字列を削除

    couponCode.innerHTML = couponCode.innerHTML.replace(/\[&nbsp;/g, '');
    couponCode.innerHTML = couponCode.innerHTML.replace(/ \&nbsp;]/g, '');
    console.debug(couponCode.innerHTML);
  });
}

function hidden_buy_button_when_ssd () {
  const searchQuery = '保守・点検オプション';
  // const productList = document.querySelectorAll('.raku2_item_bloc');
  const productList = document.querySelectorAll('.listdetail');

  // productList が存在しない場合は何もしない
  if (productList.length === 0) return;

  const buyButtonWrapper = document.querySelector('div#button_lower');

  productList.forEach(function (product) {

    // HTMLタグと改行を削除してテキストをクリーンアップ
    const cleanText = product.textContent.replace(/<[^>]*>?/gm, '').replace(/\s+/g, ' ').trim();
    // console.debug(cleanText);

    // const productOptionName = product.querySelector('.mini').textContent;
    const productOptionName = cleanText;
    // console.debug(productOptionName);

    // 商品名に検索クエリが含まれているか確認
    if (productOptionName.includes(searchQuery)) {
      // 含まれている場合は「購入」ボタンを非表示にする
      if (!buyButtonWrapper.classList.contains('has-ssd')) {
        buyButtonWrapper.classList.add('has-ssd');
      }

    }

  });

}

function debug_js_hidden() {
  const debugElements = document.querySelectorAll('.js-debug');

  if (!debugElements) return;

  const urlParams = new URLSearchParams(window.location.search);
  const debugParam = urlParams.get('debug');

  if (debugParam === 'true') {
    debugElements.forEach(function (element) {
      element.style.display = 'block';
    });
  }

}

// function hide_addcart_button() {
//   const statusIcon = document.querySelector('.status_icon');

//   // statusIcon の子要素を確認して有無を確認
//   if (statusIcon === null || statusIcon.children.length === 0) return; // ない場合は何もしない
//   // if (statusIcon === null) return; // ない場合は何もしない

//   console.debug(statusIcon.children);
// }



document.addEventListener('relatedProductsReady', related_product);

document.addEventListener('DOMContentLoaded', function () {
  // hide_addcart_button();
  //format_coupon_code();
  hidden_buy_button_when_ssd();
  add_estimate_pdf_button();
  ui_tab();
  hide_pointsection_order();
  view_change_init();
  custom_staff_info_text();

  // デバッグモードの要素表示
  debug_js_hidden();

  custom_default_shipping_address();


  //mobile_menu_init();
});
